/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Typography, Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "./../sass/purchase.module.scss";
import { useSelector } from "react-redux";

const DisplayBalance = ({action,symbol}) => {
  const [balance, setBalance] = useState(null);
  const { list, loading } = useSelector((state) => state.balance);
  useEffect(() => {
    if(!loading) {
      const findBalance = list.find((balance) => {
        
        if(action === "buy" && balance.asset?.symbol === "tether") {
          return balance;
        } else if(action === "sell" && balance.asset?.symbol === symbol) {
          return balance;
        } else return null;
      });
      console.log("findBalance",findBalance)
      setBalance(findBalance);
    }
  },[loading,list,symbol]);

  if(loading) {
    return <Skeleton className="mb-2"/>
  }

  return (
    <div 
      className={classNames(
        styles["balance"],
        "d-flex align-items-center justify-content-between mb-2"
      )}
    >
      <Typography variant="body1">
        Your Balance
      </Typography>
      <Typography variant="body1" fontWeight={600}>
        {
          balance ? (
            <>
              { 
                balance.asset.symbol === "tether" ? (
                  balance.amount.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                ) : (
                  balance.amount + " " + balance.asset.display_symbol
                )
              }
            </>
          ) : (
            "$0"
          )
        }
      </Typography>
    </div>
  )
}

const PurchasePreview = ({ amount, symbol, swap, action }) => {

  // redux
  const { list } = useSelector((state) => state.assets);
  const { loggedin } = useSelector((state) => state.app);

  // logic
  const asset = list.find((item) => {
    return item.symbol === symbol;
  });

  return (
    <>
      <div
        className={classNames(
          styles["purchase-preview"],
          ""
        )}
      >
        <Typography variant="h4">Order Preview</Typography>
        {
          loggedin && <DisplayBalance action={action} symbol={symbol}/>
        }
        <div className="d-flex align-items-center justify-content-between mb-2">
          <Typography variant="body1">
            Amount {
              action === "buy" ? (
                <>
                  {swap === "value" ? "to spend" : "to buy"}
                </>
              ) : (
                "to sell"
              )
            }
          </Typography>
          <Typography variant="body1">
            <strong className={classNames(styles["truncate"])}>
              {
                swap === "value" ? (
                  (parseFloat(amount)).toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                ) : (
                  amount + " " + symbol
                )
              }

            </strong>
          </Typography>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <Typography variant="body1">
            Price
          </Typography>
          {swap === "amount" ? (
            <Typography variant="body1">
              1 {asset.display_symbol} = <strong>${(action === "sell" ? asset.bid : asset.ask).toFixed(2)}</strong>
            </Typography>
          ) : (
            <Typography variant="body1">
              $1 = {(1 / (action === "sell" ? asset.bid : asset.ask)).toFixed(2)} {asset.display_symbol}
            </Typography>
          )}
        </div>
        <div className="d-flex justify-content-between">

          <div>
            <Typography variant="body1">
              Total {swap === "value" && "recieved"}
            </Typography>
          </div>
          
          <Typography variant="body1">
            <strong className={classNames(styles["truncate"])}>
              {swap === "amount"
                ? (amount * (action === "sell" ? asset.bid : asset.ask)).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                }) : (amount / (action === "sell" ? asset.bid : asset.ask)).toFixed(3) + " " + asset.display_symbol}
            </strong>
          </Typography>
        </div>
      </div>
    </>
  );
};

export default PurchasePreview;
